const scheduledServicesCalendarFilterModal = {
  filter: 'FILTROS',
  clear: 'Limpiar Filtros',
  site: 'Sitios',
  user: 'Responsable',
  groups: 'Grupo',
  place: 'Lugar',
  area: 'Departamentos',
  company: 'Empresa Tercera',
  equipmentModel: 'Tipo de Equipo',
  frequencies: 'Frecuencias',
  serviceTypes: 'Tipos de Servicio',
  cancel: 'CANCELAR',
  ok: 'APLICAR'
};

export default scheduledServicesCalendarFilterModal;
